import { Link } from "react-router-dom";
import { useAllBlogPosts } from "@/hooks/useBlogPosts";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Plus, Pencil, Eye, EyeOff } from "lucide-react";
import { Loader2 } from "lucide-react";

export default function AdminBlog() {
  const { data: posts = [], isLoading } = useAllBlogPosts();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="container px-6 py-8 max-w-4xl relative">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold">Blog Posts ({posts.length})</h2>
        <Button size="sm" asChild>
          <Link to="/blog/new">
            <Plus className="mr-2 h-4 w-4" />
            New Post
          </Link>
        </Button>
      </div>

      <div className="space-y-3">
        {posts.map((post) => (
          <Card key={post.id} className="flex items-center gap-4 p-4">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="font-medium">{post.title}</span>
                {!post.published ? (
                  <Badge variant="secondary" className="text-xs">
                    <EyeOff className="h-3 w-3 mr-1" />
                    Draft
                  </Badge>
                ) : (
                  <Badge variant="outline" className="text-xs">Published</Badge>
                )}
              </div>
              <p className="text-sm text-muted-foreground truncate">{post.excerpt}</p>
              <p className="text-xs text-muted-foreground mt-1">
                {post.author_name} · {new Date(post.created_at).toLocaleDateString()}
              </p>
            </div>
            <div className="flex gap-1">
              <Button variant="ghost" size="icon" asChild>
                <Link to={`/blog/${post.slug}`}>
                  <Eye className="h-4 w-4" />
                </Link>
              </Button>
              <Button variant="ghost" size="icon" asChild>
                <Link to={`/blog/${post.slug}/edit`}>
                  <Pencil className="h-4 w-4" />
                </Link>
              </Button>
            </div>
          </Card>
        ))}
        {posts.length === 0 && (
          <p className="text-sm text-muted-foreground py-4">No blog posts yet.</p>
        )}
      </div>
    </div>
  );
}
